import { fromJS } from 'immutable';
import I18n from 'I18n';
import ReportCard from 'reporting-enablement/components/PlatformReport/ReportCard';
// @ts-expect-error Untyped module
import ReportingActionsLoader from 'reporting-action-components/reportingActions/AsyncReportingActionsLoader';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { DATA_WELL } from 'reporting-data/constants/chartTypes';
import { PRIOR_PERIOD } from 'reporting-data/constants/compareTypes';
import { AGGREGATION } from 'reporting-data/constants/configTypes';
import { ANALYTICS_ALL_PAGES, ANALYTICS_ALL_PAGES_SOURCES } from 'reporting-data/constants/dataTypes';
import { EQ, IN } from 'reporting-data/constants/operators';
import { useReportingFiltersProvider } from '../../providers/ReportingFiltersProvider';
import { getValidatedMetricsToDisplay } from '../../utils/reportingUtils';
import useReportingContentIds from '../../hooks/useReportingContentIds';
import { jsx as _jsx } from "react/jsx-runtime";
const getCustomFilters = ({
  contentIds,
  contentId,
  d1,
  source
}) => {
  if (contentIds && contentIds.length > 0) {
    return [{
      operator: IN,
      property: 'filters',
      values: contentIds
    }];
  }
  const defaultFilters = [{
    operator: EQ,
    property: 'pageId',
    value: contentId
  }];
  if (!source) {
    return defaultFilters;
  }
  if (!d1) {
    defaultFilters.push({
      operator: EQ,
      property: 'd1',
      value: source
    });
    return defaultFilters;
  }
  defaultFilters.push({
    operator: EQ,
    property: 'd1',
    value: source
  }, {
    operator: EQ,
    property: 'd2',
    value: d1
  });
  return defaultFilters;
};
const getDisplayParams = ({
  isViewingAllVariations
}) => {
  // const rhumbConfig = getReportRhumbConfig('SOURCES_DATA_WELLS_LOADED');

  if (isViewingAllVariations) {
    return {
      render: {
        action: () => null
      }
      // rhumbConfig,
    };
  }
  return {
    render: {
      action: () => undefined
    }
    // rhumbConfig,
  };
};
const getReport = ({
  contentIds,
  contentId,
  dateRange,
  d1,
  metricsToDisplay,
  source
}) => {
  const isViewingAllVariations = Boolean(contentIds && contentIds.length > 0);
  if (!(contentId || isViewingAllVariations)) {
    return null;
  }
  const metricsList = metricsToDisplay.map(metricToDisplay => ({
    property: metricToDisplay
  }));
  return {
    chartType: DATA_WELL,
    config: {
      compare: PRIOR_PERIOD,
      configType: AGGREGATION,
      dataType: isViewingAllVariations ? ANALYTICS_ALL_PAGES : ANALYTICS_ALL_PAGES_SOURCES,
      dimensions: [],
      filters: {
        custom: getCustomFilters({
          contentIds,
          contentId,
          d1,
          source
        }),
        dateRange: {
          property: 'sessionDate',
          value: dateRange
        }
      },
      metrics: metricsList
    },
    displayParams: getDisplayParams({
      isViewingAllVariations
    })
  };
};
const SourcesDataWell = ({
  metricsToDisplay,
  variationId,
  variationIds
}) => {
  const {
    allMetricsData,
    dateRange,
    d1,
    metricsToDisplay: selectedMetricsToDisplay,
    source
  } = useReportingFiltersProvider();
  const {
    contentId,
    contentIds
  } = useReportingContentIds({
    variationId,
    variationIds
  });
  const report = getReport({
    contentIds,
    contentId,
    dateRange,
    d1,
    metricsToDisplay: metricsToDisplay ? getValidatedMetricsToDisplay(metricsToDisplay, allMetricsData) : selectedMetricsToDisplay,
    source
  });
  return /*#__PURE__*/_jsx(ReportingActionsLoader, {
    children: /*#__PURE__*/_jsx(ReportCard, {
      header: I18n.text('content-management-details-lib.reporting.sourcesDataWell.title'),
      height: "auto",
      children: /*#__PURE__*/_jsx(PlatformReportResolver, {
        report: fromJS(report),
        useInlineLabels: false
      })
    })
  });
};
export default SourcesDataWell;